import BaseNavbar from "./shared/BaseNavbar";
import BrandLogo from "./shared/BrandLogo";
import MobileMenuTrigger from "./shared/MobileMenuTrigger";
import NavbarLink from "./shared/NavbarLink";
import Dropdown from "../auxiliar/ui/Dropdown";

const NavbarLoggedOut = () => {
    const getLinks = () => [
        { to: "/login", label: "Iniciar sesión", variant: "primary", position: 1 },
        { to: "/register", label: "Registro", variant: "primary", position: 2 },
        { to: "/info", label: "Información", position: 3 },
    ];

    const startContent = (
        <>
            <Dropdown trigger={<MobileMenuTrigger />} items={getLinks()} className="xl:hidden" />
            <BrandLogo to="/login" size="desktop" />
        </>
    );

    const centerContent = (
        <>
            <div className="px-1 hidden xl:flex gap-1 items-center">
                {getLinks()
                    .sort((a, b) => a.position - b.position)
                    .map((link) => (
                        <NavbarLink key={link.to} to={link.to} variant={link.variant}>
                            {link.label}
                        </NavbarLink>
                    ))}
            </div>
            <BrandLogo to="/login" size="mobile" />
        </>
    );

    return <BaseNavbar startContent={startContent} centerContent={centerContent} />;
};

export default NavbarLoggedOut;
